import React from "react";

const Icon = ({
  name,
  style,
  className,
}: {
  name: string;
  style?: React.CSSProperties;
  className?: string;
}) => {
  return <i className={`icon-${name} ${className}`} style={style}></i>;
};

export default Icon;
